<template>
    <component
    v-if="showPage && getComponent(props.item['tp'])"
    :is="getComponent(props.item['tp'])"
    :config="item"
    :param-form-data="paramFormData"
    :route-params="routeParams"
    :form-data="formData"
    :front-id="frontId"
    :prepair="prepair"
    :rules="rules"
    :msgdialog="msgdialog"
    :from-id="fromId"
    @on-change="onChange($event)"
    @btn-submit-action="btnSubmitAction($event)"
    @btn-row-edit="btnRowEdit($event)"
  />
</template>

<script setup lang="ts">
import mitt from 'mitt-utils';
import { generateToast, isEmpty, isN, isNN } from '../../utils/tools';
import { nextTick, onBeforeUnmount, ref,onMounted } from 'vue';
import { useRoute } from 'vue-router';
import {  getPid } from 'exeAction-utils';
//form-data 是因为返回 撤销而增加的，什么场景，是现在没用了么？
import { validItemVi } from '../actionUtils/apiTools';
import { getComponent } from 'componentRegistry-utils';
import { useUserStore } from '../../store/modules/user';
import { preferenceStore } from 'preferenceStore-utils';
import { appendStyle } from '../actionUtils/cssUtils';

//  字典那个 保存完要反回上一个值
//:param-form-data="paramFormData" 只要该子项不可能是form子项就不加
//:route-params="routeParams" 只要路由不向这里传递就不加

//之前发生去掉import upload_t直接导入tupload，结果上传按钮出不来的问题

//emits onChange如何使用：
//1、最直接的在界面上手写或选择的控件，
//     子：比如input,select等在合适的地方使用emits到父级
//     父：定义onChange（这里由于content-item承接，因此也需要实现onChange进一步向上发送
//     最终：在需要进一步承接的上实现@onChange及onChange的具体处理
//     典型：input > content-item > form，在form上实现了onChange
//          page 自身onChange > content-item > table上实现分页
//2、有的控件如div自身不需要手动操作，但需要进一步向上反馈信息，比如upload，tag的tagv变量
//     场景：div包含若干控件，比如upload和tag，若其作为form的子项，如果变化了需要通知父项，让提交时能获取值
//          upload/tag emit > div > emit > form onChange从而让form能感知变化
//3、注意：有些控件自身就有onChange的实现，两者不要混淆了。同时
//   todo 一个问题：自实现的onChange到父控件的onChange上和父控件自身的onChange会不会冲突？待验证

const route = useRoute();
//用于向父控件传值
const emits = defineEmits(['onChange', 'btnRowEdit', 'btnSubmitAction']);
//props用于从父控件获取传递来的值
//注意：如果是包含content-item，里面叫:item，具体实现名字都是:config
const props = defineProps({
  item: {
    type: Object,
    default: ()=>{ return {};}
  },
  paramFormData: {
    type: Object || String,
    default: ()=>{ return {};}
  },
  routeParams: {
    type: Object,
    default: ()=>{return {};}
  },
  gids: {
    type: Object,
    default: ()=>{ return {};}
  },
  formData: {
    type: Object,
    default: ()=>{ return {};}
  },
  rules: {
    type: Array,
    default: ()=>{ return [];}
  },
  msgdialog: {
    type: Boolean,
    default: false
  },
  prepair: {
    type: Object,
    default: ()=>{ return {};}
  },
  //当前用于分页器，表示哪个组件绑定了分页器。标识绑定者的did
  fromId: {
    type: Number,
    default: 1
  },
  onChange: Function,
});


const pid = getPid(route);
const n = `fitem ${isNN(props.item['did'])?props.item['did']:''}/${isNN(props.item['attr']) && isNN(props.item['attr']['k'])?props.item['attr']['k']:''}> `;
const userStore = useUserStore();

//setup中接收的props是响应式的，当传入新的props时，会被及时更新。
//由于是响应式的，所以不可使用ES6结构，解构会消除它的响应式
// ref https://segmentfault.com/a/1190000040050254
//let { did }   = props['item'];
// console.log("++++++++++props ", props);


//todo 所有控件的父级都是content-item

//值改变事件(原本是设计给form使用，当前只要支持valchange即可支持)
//因为content-item是每个控件的父级，要想传到真正的父级控件，需要进一步emits才能实现
//基础控件都有如valchange,处理valchanged目前有form,table等
const onChange = (v:any)=>{
  console.log(`${n}onChange:`,v);
  //undefined也要上传
  emits('onChange', v);

  // 缓存当前值：需要该控件有did，且设置了key，因为存储时使用unid+pid+did+key
  // 该值用于实现类似，用户登录一次之后，下次再登录就使用上次默认值--从而实现类似用户个性选择被记住
  // 行为：F5刷新不改变，退出重新登录不改变；清理缓存会被清除--但也只是清除自己的缓存
  nextTick(()=>{
    const { item } = props;
    if(isNN(item['attr']) && item['attr']['s'] === true){
      let key = item['attr']['k'];
      //只要有did或key就保存，只有key可能会存在两个同名key控件值冲突
      //did可以不设置。对于key同名多个的，只要设置了did肯定不会有问题
      if(isN(item['did']) && isN(key)){
        console.error('local save. but no did, no k');
      }else{
        console.log("local storage clear/set", v[key]);
        //todo 这块需要把当前版本加上去或者后期考虑把路由固定下来
        //否则会本地缓存很多无用的数据
        if(isEmpty(v[key])){//清除掉
          preferenceStore.remove(`${pid}_${item['did']}_${key}`);
        }else{;//设置缓存
          if(Array.isArray(v[key])){//checkgroup
            let arr = [];
            let i = 0;
            for(let val of v[key]){
              arr[i++] = val['value'];
            }
            preferenceStore.set(`${pid}_${item['did']}_${key}`, arr);
          }else{;
            //如果是object类型的，按对象存储，比如select，包含了当前选项或选项列表
            if(typeof v[key] === 'object'){
              preferenceStore.set(`${pid}_${item['did']}_${key}`, JSON.stringify(v));
            }else{;
              preferenceStore.set(`${pid}_${item['did']}_${key}`, v[key]);
            }
          }
        }
      }
    }
  });
};

const btnRowEdit = (v) =>{
  console.log(`${n}btn row edit`);
  emits('btnRowEdit', v);
}

const btnSubmitAction = (v)=>{
  console.log(`${n}submit`, v);
  emits('btnSubmitAction', v);
}

// 错误界面item
let frontId:number = new Date().getTime();
// console.log(`${n} frontid: ${frontId}, tp:${props.item['tp']}`);

//整体控制是否渲染
let showPage = ref();//开始不要给初始值，否则就是先渲染出来
const visibilty = ()=> {
  //如果有且能满足条件再显示
  let vis = props.item['attr'];
  //没有就渲染
  if(isN(vis) || isN(vis['vi'])){
    return true;
  }

  //这里只能获得路由参数和缓存
  return validItemVi(vis['vi']['{v}'],  props.routeParams, undefined, undefined, undefined, vis['vi']['{c}']);

}
showPage.value = visibilty();

//定时更新，进行重绘(每隔指定时间执行，等待结果获取后，再次启动，并不是直接循环执行)
/*let intv = ref();
const cycleAction = props.item['cycle'];
if(isNN(cycleAction) && isJsonV(cycleAction)){
  //换算为秒
  let sec = cycleAction['p']['{t}'];
  if(isNN(sec) && sec >0){
    sec *= 1000;
    let n = 0;
    intv.value = setInterval(()=>{
      if(n>=0){
        n++;
      }
      
      delete cycleAction['p']['{t}'];//不删除，该参数会带到body上
      //触发保存的条件：超过指定的字数，或者指定的定时器次数（如5秒一次，60次，则是5分钟）
      if((cycleAction['p']['{n}'] && Math.abs(ctNew - ctOld) >= cycleAction['p']['{n}']) || n > 60){
        exeAction(router, cycleAction, {}, pid, props.frontId);
        ctOld = ctNew;
        //对于超时触发的执行，只触发一次。如用户离开，不必一直触发
        if(n > 60){
          n = -1;
        }
      }
    }, sec);
  }
}*/



//msgFrontObj是commsg的数据，如果有结果就会显示出来
//let msgFrontObj = ref(null);
//加frontId是为了解决使用popWind包裹的批量删除时，后面再删除无法出现删除成功框的问题，
//分析应该是批删的popWin使用的frontID在删除完再次渲染后已经找不到原始的位置了
//不带FrontId则匹配不上
mitt.on(`apiToast_${frontId}`, (par: any) => {
  generateToast(par);
  /*const {fid, fitem} = par;
  // console.log("frontId apiToast 监听 = 接受="+fid,"#原始ID#="+frontId.value, par);
  if(fid === frontId){    
    if(msgFrontObj.value == null || msgFrontObj.value == undefined){
      toast('弹框出错');
      //return;
    }
    toastErr(msgFrontObj, fitem);
  }*/
});



onMounted(()=>{
  if(isNN(props.item['attr']?.['cls'])){
    appendStyle(props.item['attr']['cls']);
  }
})

onBeforeUnmount(() => {
  mitt.off(`apiToast_${frontId}`);
});
</script>

<style lang="scss" scoped>

</style>
